import { bootstrapApplication } from '@angular/platform-browser';
import {
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
  PreloadAllModules,
} from '@angular/router';
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  OAuthModule,
  OAuthService,
  OAuthStorage,
  provideOAuthClient,
} from 'angular-oauth2-oidc';
import {
  provideServiceWorker,
  ServiceWorkerModule,
} from '@angular/service-worker';
import {
  APP_INITIALIZER,
  importProvidersFrom,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { environment } from './environments/environment';
import { IonicStorageModule, provideStorage } from '@ionic/storage-angular';
import { LocalizationService } from './app/services/localization.service';
import { NgCircleProgressModule } from 'ng-circle-progress';

const host = window.location.hostname;
const isLocalDev = host === 'localhost' || host === '127.0.0.1';

//TODO cette fonction ne semble pas etre appelé
export function storageFactory(): OAuthStorage {
  return localStorage;
}

export function getProviders(): any {
  return [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: OAuthStorage, useFactory: storageFactory },
    provideIonicAngular({
      mode: 'ios', // Force le mode iOS sur toutes les plateformes
    }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptorsFromDi()),

    importProvidersFrom(
      OAuthModule.forRoot({
        resourceServer: {
          allowedUrls: [environment.backendUri + '/api'], // tes URLs d’API
          sendAccessToken: true, // ⚡ token automatiquement ajouté
        },
      }),
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json',
      }),
      fallbackLang: 'fr',
      lang: 'fr',
    }),
    importProvidersFrom(IonicStorageModule.forRoot()),
    importProvidersFrom(
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: !isLocalDev,
      }),
    ),
    importProvidersFrom(
      NgCircleProgressModule.forRoot({
        // set defaults here
        radius: 100,
        outerStrokeWidth: 16,
        innerStrokeWidth: 8,
        outerStrokeColor: '#78C000',
        innerStrokeColor: '#C7E596',
        animationDuration: 0,
      }),
    ),

    provideAppInitializer(async () => {
      const oauthService = inject(OAuthService);

      oauthService.setStorage(localStorage);

      oauthService.configure({
        issuer: environment.backendUri,
        scope: 'USER',
        redirectUri: window.location.origin,
        clientId: environment.backendOAuthClientId,
        dummyClientSecret: environment.backendOAuthClientSecret,
        requireHttps: environment.mode !== 'development',
        tokenEndpoint: environment.backendUri + '/oauth/v2/token',
        userinfoEndpoint: `${environment.backendUri}/api/v1/user-bundle/users/me`,
        oidc: false,
      });

      const localizationService = inject(LocalizationService);
      await localizationService.initialize();
    }),
  ];
}

bootstrapApplication(AppComponent, {
  providers: getProviders(),
});
